module.exports = __webpack_public_path__ + "img/black_friday_deal_text_m.3f82f25.svg";